// components
import { styled, Box, BoxProps, alpha } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const StyledSignalIconTopBox = styled(Box)<BoxProps>(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center'
}));

export const StyledSignalIconBottomBox = styled(StyledSignalIconTopBox)(() => ({
  top: 'unset',
  bottom: 0
}));

export const StyledSignalIcon = styled(Icon)(({ theme }) => ({
  width: theme.spacing(3.5),
  height: theme.spacing(3.5),
  color: alpha(theme.palette.text.primary, 0.5)
}));
